import axios from '@/utils/axios'

export default {
  loginFromThirdParty: async (params: any): Promise<any> => {
    return await axios.get('/i-guidance/user/no-pass-login', {params})
  },
  loginFromSmallProgram: async (params: any): Promise<any> => {
    return await axios.get('/i-guidance/user/ehos-login', {params})
  },
  getUserInfo: async (): Promise<any> => {
    return await axios.get('/i-guidance/user/user')
  }
}
